import React, { useState, useContext, useEffect, Fragment } from 'react';
import styled from 'styled-components';
import { path } from 'ramda';
import { Trivia } from '../../_components';
import { ButtonYellow, Badge } from '../../_elements';
import { breakpoints } from '../../_helpers/breakpoints';
import { ContentContext } from '../../_context';
import { HiArrowRight } from "react-icons/hi";
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import trophy from '../../_assets/images/trophy.png';
import trivia_star_sp from '../../_assets/images/trivia_star_sp.png';
import { RiCloseCircleLine } from "react-icons/ri";

import { Fade,
         Backdrop } from '@material-ui/core';

const ModalTriviaStyled = styled(Modal)`
  display: flex;
  justify-content: center;
  //align-items: center;
  color: #FFF;
  &.scrolleable{
    position: absolute;
    overflow: scroll;
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  
  .inner_modal_contact_message{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* width: 100vw;
    height: 100vh; */
    width: calc(100% - 30px);
    height: auto;
    padding: 5vw;
    background-color: #991813;
    outline: 0!important;
    border-radius: 16px;
    .texto_mensaje{
      width: calc(100% - 50px);
      text-align: left;
      .highlighted{
        font-size: 18px;
        line-height: 30px;
        margin-top: 10px;
      }
    }
    .errorMessages{
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 10px;
      border: 1px dashed #F20000;
      background-color: #FF9494;
      color: #000000;
      padding: 6px 10px 6px 10px;
      font-size: 15px;
      line-height: 19px;
      p{

      }
    }
    .successMessages{
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 10px;
      background-color: #B8FF6D;
      //#F7DECC,#AD8D75,#B8FF6D,#1B110A,#E0C0A8,#F7DECC,#AD8D75,#B8FF6D
      border: 1px dashed #33E46D;
      color: #000000;
      padding: 6px 10px 6px 10px;
      font-size: 15px;
      line-height: 19px;
    }

    .title{
      width: 80vw;
      margin-top: 0;
      //margin-bottom: 6vw;
      p{
        text-align: left;
        font-size: 7vw;
        line-height: 8.5vw;
        width: 100%;
      }
    }

    .contact_form{
      display: flex;
      flex-direction: column;
      width: 100%;

      .field_channel{
        margin-bottom: 20px;
      }
      .field_subject{
        margin-bottom: 20px;
      }
      .field_message{
        margin-bottom: 10px;
      }
      .modal_actions{
        .loader{
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 250px;
          height: 40px;
          //margin-top: 6px;
          svg{
            color: #FFD200;
          }
        }
      }

      .is_invalid{
        border: 1px solid red!important;
      }
      .fix_is_invalid{
        border: 0;
      }

      .field{
        label{
          display: flex;
          width: 100%;
          font-size: 16px;
          line-height: 16px;
          font-weight: 600;
          color: #000000;
          margin-bottom: 7px;
        }
        input{
          display: flex;
          padding: 10px;
          border: 1px solid #CCCCCC;
          border-radius: 6px;
          width: 100%;
        }
        textarea{
          display: flex;
          padding: 10px;
          border: 1px solid #CCCCCC;
          border-radius: 6px;
          width: 100%;
        }
        select{
          display: flex;
          padding: 10px;
          border: 1px solid #CCCCCC;
          border-radius: 6px;
          width: 100%;
        }
      }
    }
  }

  &.scrolleable{
    //padding-top: 0;
    //padding-bottom: 0;
  }

  @media ${breakpoints.xs} {
    
    .inner_modal_contact_message{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: calc(100% - 30px);
      height: auto;
      padding: 25px;
      outline: 0!important;
      border-radius: 16px;

      .title{
        width: calc(100% - 40px);
        margin-top: 0;
        margin-bottom: 0;
        p{
          text-align: left;
          font-size: 37px;
          line-height: 40px;
          width: 100%;
        }
      }

    }
  }
  @media ${breakpoints.sm} {
    &.scrolleable{
      padding-top: 20px;
      padding-bottom: 20px;
    }
    
    .inner_modal_contact_message{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 700px;
      height: auto;
      padding: 25px;
      outline: 0!important;
      border-radius: 16px;

      .title{
        width: 100%;
        margin-top: 0;
        margin-bottom: 0;
        p{
          text-align: left;
          font-size: 37px;
          line-height: 40px;
          width: 100%;
        }
      }

    }
  }
  @media ${breakpoints.md} {
    
  }
  @media ${breakpoints.lg} {

  }
`
  
const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border: 2px solid rgba(246,199,68,1)!important;
  padding-bottom: 30px;
  -webkit-box-shadow: 5px 5px 15px -10px #000000;
  box-shadow: 5px 5px 15px -10px #000000;

  .trivia_bottom_actions{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .bt{
      margin-top: 15px;
      width: 150px;
      height: 34px;
    }
  }
  .trivia_endend{
    width: 100%;
    text-align: center;
    font-size: 20px;
    line-height: 20px;
    font-weight: 600;
    padding-top: 35px;
  }
  .loader{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    margin-top: 20px;
    svg{
      color: #FFC600;
    }
  }

  .title_tab{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    >p{
      font-size: 15px;
      line-height: 15px;
      margin: 0;
      padding: 0;
      padding-top: 1px;
    }
  }
  .MuiTab-root{
    color: #212529!important;
    .Mui-selected{
      color: #212529!important;
      font-weight: 600;
    }
  }
  .MuiTabs-indicator{
    background-color: #FFC600!important;
  }
  .tabs_box{
    background: rgb(247,162,41);
    background: linear-gradient(90deg, rgba(247,162,41,1) 0%, rgba(255,197,0,1) 100%);
    padding: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom: 0!important;
    .trivia_header_user_data{
      display: flex;
      //margin-top: 15px;
      .trivia_box_points{
        display: flex;
        flex-direction: row;
        .trivia_icon{
          display: flex;
          width: 100px;
          img{
            float: left;
            width: 100%;
          }
        }
        .trivia_data{
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 20px;
          .trivia_points{
            .trivia_label{
              font-size: 14px;
              line-height: 14px;
              font-weight: 500;
            }
            .trivia_value{
              font-size: 40px;
              line-height: 40px;
              font-weight: 800;
              margin-top: 3px;
            }
          }
          .trivia_ranking{
            margin-left: 20px;
            border-left: 1px solid black;
            padding-left: 20px;
            color: #D8010F!important;
            .trivia_label{
              font-size: 14px;
              line-height: 14px;
              font-weight: 500;
            }
            .trivia_value{
              font-size: 40px;
              line-height: 40px;
              font-weight: 800;
              margin-top: 3px;
            }
          }
        }
      }
    }
  }
  .panel_tab{
    //padding: 0 20px;
  }
  .panel_tab_podium{
    background: rgb(247,162,41);
    background: linear-gradient(90deg, rgba(247,162,41,1) 0%, rgba(255,197,0,1) 100%);
  }
  .tabs{
    width: 100%;
    //background-color: pink;
    .tab{
      width: 50%;
      max-width: 50%!important;
      font-weight: 600;
      font-size: 16px;
      border: 1px solid #D8010F;
      &.Mui-selected{
        background-color: #ffc600!important;
        p{
          color: #000000!important;
        }
      }
      &.tab_trivia{
        background-color: #D8010F;
        color: #FFFFFF!important;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        //border-right: 1px solid #FFFFFF;
      }
      &.tab_ranking{
        background-color: #D8010F;
        color: #FFFFFF!important;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        //border-left: 1px solid #FFFFFF;
        //
      }
    }
  }

  .elements{
    margin-top: 15px;
    padding: 0 20px;
    .element{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 20px 20px;
      border: 1px solid #EAEAF0;
      border-bottom: 3px solid #EAEAF0;
      border-radius: 12px;
      cursor: not-allowed;
      margin-bottom: 15px;
      :last-child{
        margin-bottom: 0;
      }
      .left{
        display: flex;
        flex-direction: row;
        width: calc(100% - 35px);
        .image{
          display: flex;
          width: 83px;
          height: 83px;
          margin-right: 15px;
          border-radius: 6px;
          overflow: hidden;
          border: 1px solid #EAEAF0;
          img{
            float: left;
            width: 100%;
          }
        }
        .data{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: calc(100% - 83px);
          .title{
            font-size: 16px;
            line-height: 16px;
            font-weight: 600;
          }
          .label_status{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 13px;
            line-height: 13px;
            font-weight: 800;
            margin-top: 10px;
            .text_status_game{
              font-size: 15px;
              line-height: 15px;
              color: rgb(247,162,41);
              margin-left: 10px;
            }
            .score{
              color: #FFC600;
              margin-left: 10px;
            }
            .retry,
            .pending,
            .viewed,
            .approved,
            .blocked,
            .ended{
              padding: 5px 7px;
              box-sizing: border-box;
              border-radius: 6px;
              margin-right: 0;
              /* margin-bottom: 2vw; */
            }
            .ended{
              color: #616161;
              border: 2px solid #616161;
              background-color: #FFFFFF;
            }
            .retry{
              border: 2px solid #C5000D;
              background-color: #C5000D;
            }
            .pending{
              border: 2px solid #616161;
              background-color: #616161;
            }
            .viewed{
              border: 2px solid #FFC600;
              background-color: #FFC600;
            }
            .approved{
              border: 2px solid #006F45;
              background-color: #006F45;
            }
            .blocked{
              color: #C5000D;
              border: 2px solid #C5000D;
              background-color: transparent;
              margin-right: 0;
            }
          }
        }
      }
      .right{
        .icon_arrow{
          display: flex;
          /* width: 25px; */
          width: 35px;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-end;
          margin-left: auto;
          font-size: 20px;
          color: #212529;


        }
      }
      &.active{
        cursor: pointer;
      }
      &.active:hover{
        border-bottom: 3px solid #FFC600;
        .right{
          .icon_arrow{
            color: #FFC600;
          }
        }
      }
    }
  }

  .evaluation_question_tabs{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    .question_tab{
      height: 2px;
      width: ${props => props.questions_total ? `calc(100% / ${props.questions_total} - 10px)` : "0"};
      background-color: #BFBFBF;
      &.active{
        background-color: #FFC600;
      }
      &.correct{
        background-color: green;
      }
      &.incorrect{
        background-color: red;
      }
    }
  }

  .box_ranking{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 0!important;
    
    .own_ranking_data{
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 5vw 5vw;
      width: 100%;
      border: 2px dashed #FFC600;
      background-color: rgba(255,198,0,0.025);
      margin-bottom: 5vw;
      border-radius: 12px;
      .own_points,
      .own_position{
        display: flex;
        flex-direction: column;
        align-items: center;
        .label{
          font-size: 3.5vw;
          line-height: 3.5vw;
          font-weight: 600;
        }
        .value{
          font-size: 11vw;
          line-height: 11vw;
          font-weight: 800;
          margin-top: 2vw;
          color: #FFC600;
        }
      } 
      .own_points{
        margin-right: 45px;
      }
      .own_position{

      }
    }
    .top{
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      align-self: center;
      justify-content: center;
      width: 100%;
      position: relative;
      //overflow-x: hidden;
      .box_podium{
        display: flex;
        justify-content: center;
        //width: 100%;
        width: 100%;
        height: 73vw;
        background-image: url("images/fondo_ranking.png");
        background-position: center 0;
        background-repeat: no-repeat;
        background-size: cover;
        .podium{
          width: 70vw;
          position: absolute;
          bottom: -2vw;
          img{
            float: left;
            width: 100%;
          }
        }
        .podium_1,
        .podium_2,
        .podium_3{
          display: flex;
          flex-direction: column;
          align-items: center;
          .name{
            font-size: 3vw;
            line-height: 3.1vw;
            text-align: center;
            margin-top: 2vw;
          }
          .points{
            display: flex;
            flex-direction: row;  
            background-color: #FFFFFF;
            padding: 0.7vw 2.1vw;
            border-radius: 6px;
            margin-top: 0.7vw;
            .value{
              font-size: 3.5vw;
              line-height: 3.5vw;
              font-weight: 600;
            }
            .pts{
              font-size: 3.5vw;
              line-height: 3.5vw;
              margin-left: 0.5vw;
            }
          }
          .image{
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 9vw;
            overflow: hidden;
            width: 16vw;
            height: 16vw;
            //margin-top: 10px;
            border: 4px solid #EAEAF0;
            img{
              float: left;
              width: 100%;
            }
          }
        }
        .podium_1{
          position: absolute;
          width: 23.5vw;
          left: calc(50% - 13vw);
          //top: -9vw;
          bottom: 45vw;
          //background-color: pink;
          .crown{
            width: 8vw;
            position: absolute;
            top: -2vw;
            right: 2vw;
            img{
              width: 100%;
              float: left;
            }
          }
        }
        .podium_2{
          position: absolute;
          width: 23.5vw;
          left: calc(50% - 39vw);
          //top: 5vw;
          bottom: 33vw;
        }
        .podium_3{
          position: absolute;
          width: 23.5vw;
          right: calc(50% - 38vw);
          //top: 15vw;
          bottom: 24vw;
        }
      }
      .position_1,
      .position_2,
      .position_3{
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        .name{
          font-size: 14px;
          line-height: 18px;
          font-weight: 500;
          margin-top: 5px;
          padding-left: 5px;
          padding-right: 5px;
          text-align: center;
        }
        .icon{
          width: 25vw;
          img{
            float: left;
            width: 100%;
          }
        }
        .base{
          width: 11vw;
          //height: 11vw;
          background-color: #FFC600;
          margin-top: 2vw;
        }
        .avatar{
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 9vw;
          overflow: hidden;
          width: 18vw;
          height: 18vw;
          margin-top: 2vw;
          border: 1px solid #EAEAF0;
          img{
            float: left;
            width: 100%;
          }
        }
      }
      .position_1{
        .base{
          height: 70px;
        }
      }
      .position_2{
        .base{
          height: 40px;
        }
      }
      .position_3{
        .base{
          height: 20px;
        }
      }
    }
    .list_ranking{
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 0;
      background-color: #FFFFFF;  
      padding: 20px 20px 0 20px;
      .items{
        display: flex;
        flex-direction: column;
        width: 100%;
        .item{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          border: 1px solid #FFFFFF;
          border-bottom: 1px solid #EAEAF0;
          box-sizing: border-box;
          padding: 20px 20px;
          border-radius: 12px;
          margin-bottom: 10px;
          &.is_own{
            border: 2px dashed #FFC600;
            background-color: rgba(255, 198, 0, 0.025);
          }
          .left{
            display: flex;
            flex-direction: column;
            justify-content: center;
            .own{
              font-size: 18px;
              line-height: 22px;
              font-weight: 700;
              color: #FFC600;
              margin-top: 7px;
            }
            .points{
              font-weight: 700;
              font-size: 28px;
              line-height: 28px;
              color: #556377;
            }
            .name{
              font-size: 18px;
              line-height: 22px;
              font-weight: 400;
              color: #252525;
              margin-top: 7px;
            }

          }
          .right{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .position{
              font-size: 20px;
              line-height: 25px;
              font-weight: 600;
              color: #DA291C;
              /*margin-top: 7px;*/
            }
            .avatar{
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 40px;
              border: 1px solid #EAEAF0;
              overflow: hidden;
              width: 80px;
              height: 80px;
              /*margin-top: 10px;*/
              margin-left: 0;
              img{
                float: left;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  @media ${breakpoints.xs} {
    .box_ranking{
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 20px;
      .own_ranking_data{
        padding: 25px 25px;
        width: 450px;
        margin-bottom: 25px;
        border-radius: 12px;
        .own_points,
        .own_position{
          .label{
            font-size: 18px;
            line-height: 18px;
          }
          .value{
            font-size: 55px;
            line-height: 55px;
            margin-top: 10px;
          }
        } 
        .own_points{
          margin-right: 45px;
        }
        .own_position{

        }
      }
      .top{
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        align-self: center;
        //justify-content: space-between;
        //width: 450px;

        .box_podium{
          height: 400px;
          background-position: center -50px;
          .podium{
            width: 400px;
            bottom: -10px;
          }
          .podium_1,
          .podium_2,
          .podium_3{
            .name{
              font-size: 16px;
              line-height: 18px;
              margin-top: 10px;
            }
            .points{
              padding: 3px 11px;
              border-radius: 10px;
              margin-top: 10px;
              .value{
                font-size: 16px;
                line-height: 16px;
              }
              .pts{
                font-size: 16px;
                line-height: 16px;
                margin-left: 3px;
              }
            }
            .image{
              border-radius: 100%;
              width: 80px;
              height: 80px;
            }
          }
          .podium_1{
            width: 120px;
            left: calc(50% - 65px);
            bottom: 255px;
            .crown{
              width: 45px;
              top: -12px;
              right: 8px;
            }
          }
          .podium_2{
            width: 120px;
            left: calc(50% - 195px);
            bottom: 185px;
          }
          .podium_3{
            width: 120px;
            right: calc(50% - 190px);
            bottom: 132px;
          }
        }

        .position_1,
        .position_2,
        .position_3{
          display: flex;
          flex-direction: column;
          /* justify-content: center; */
          align-items: center;
          .icon{
            width: 120px;
            img{
              float: left;
              width: 100%;
            }
          }
          .base{
            width: 40px;
            height: 40px;
            background-color: #FFC600;
            margin-top: 10px;
          }
          .avatar{
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 40px;
            overflow: hidden;
            width: 80px;
            height: 80px;
            margin-top: 10px;
            border: 1px solid #EAEAF0;
            img{
              float: left;
              width: 100%;
            }
          }
        }
        .position_1{
          .base{
            height: 70px;
          }
        }
        .position_2{
          .base{
            height: 40px;
          }
        }
        .position_3{
          .base{
            height: 20px;
          }
        }
      }
      .list_ranking{
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 0;//25px;
        .items{
          display: flex;
          flex-direction: column;
          width: 100%;
          .item{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            border: 1px solid #FFFFFF;
            border-bottom: 1px solid #EAEAF0;
            box-sizing: border-box;
            padding: 20px 20px;
            border-radius: 12px;
            margin-bottom: 10px;
            &.is_own{
              border: 2px dashed #FFC600;
              background-color: rgba(255, 198, 0, 0.025);
            }
            .left{
              display: flex;
              flex-direction: column;
              justify-content: center;
              .own{
                font-size: 18px;
                line-height: 22px;
                font-weight: 700;
                color: #FFC600;
                margin-top: 7px;
              }
              .points{
                font-weight: 700;
                font-size: 28px;
                line-height: 28px;
                color: #556377;
              }
              .name{
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                color: #252525;
                margin-top: 7px;
              }

            }
            .right{
              display: flex;
              flex-direction: row;
              align-items: center;
              .position{
                font-size: 20px;
                line-height: 25px;
                font-weight: 600;
                color: #DA291C;
                /*margin-top: 7px;*/
              }
              .avatar{
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 40px;
                border: 1px solid #EAEAF0;
                overflow: hidden;
                width: 80px;
                height: 80px;
                /*margin-top: 10px;*/
                margin-left: 25px;
                img{
                  float: left;
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }

  }
  @media ${breakpoints.sm} {
    .box_ranking{
      .top{
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        align-self: center;
        justify-content: center;
        width: 1120px;
      } 
    }
  }
  @media ${breakpoints.md} {

  }
  @media ${breakpoints.lg} {

  }
`
const ModalStyled = styled(Modal)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
  @media ${breakpoints.xs} {
  }
  @media ${breakpoints.sm} {
  }
  @media ${breakpoints.md} {

  }
  @media ${breakpoints.lg} {

  }
`
const ButtonClose = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 25px;
  cursor: pointer;
  right: 20px;
  top: 20px;
  z-index: 9;
  .icon{
    display: flex;
    font-size: 45px;
    color: #FFD200;
  }
  :hover{
    .icon{
      color: #000000;
    }
  }
`

function CustomTabPanel(props) {
  const { children,
          value,
          index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

const TriviaContainer = (props) => {

  const { history, location } = props;
  const [ triviaClose, setTriviaClose ] = useState(true);

  const { userData,
          triviaGame,
          setTriviaGame,
          getTriviaGame,
          trivia,
          setTrivia,
          getTrivia,
          getTriviaRanking,
          triviaRanking } = useContext(ContentContext);

  const [ value, setValue ] = useState(0);
  const [ evaluation, setEvaluation ] = useState(null);
  const [ evaluationOpen, setEvaluationOpen ] = useState(false);
  const [ triviaGameSelectedId, setTriviaGameSelectedId ] = useState(false);
  const [ triviaSelected, setTriviaSelected ] = useState(null);
  const [ evaluationData, setEvaluationData ] = useState(null);
  const [ loadingRanking, setLoadingRanking ] = useState(null);
  
  const [ userScore, setUserScore ] = useState('0');
  const [ userPosition, setUserPosition ] = useState('0');

  const [ firstPlace, setFirstPlace ] = useState(null);
  const [ secondPlace, setSecondPlace ] = useState(null);
  const [ thirdPlace, setThirdPlace ] = useState(null);

  const [ openModalTrivia, setOpenModalTrivia ] = useState(false);
  const handleCloseModalTrivia = () => {
      setOpenModalTrivia(!openModalTrivia);
  }
  
  const handleChange = (event, newValue) => {
    if(newValue === 1){
      setLoadingRanking(true);
      getTriviaRanking();
      //getTrivia();
    }
    setValue(newValue);
  };
  
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setEvaluationOpen(false)
    }
  }

  const handleGetGame = (trivia) => {
    

    const trivia_update = {...trivia};
    const getRandomQuestions = (questions, count) => {
      const uniqueQuestions = Array.from(new Set(questions));
      const shuffled = uniqueQuestions
      .map(value => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
      return shuffled.slice(0, count);
    };
    trivia_update.questions = getRandomQuestions(trivia_update.questions, trivia_update.count);

    //const randomQuestions = getRandomQuestions(trivia_update.questions, trivia_update.count);
    //return null;

    setEvaluation(trivia_update);
    setEvaluationOpen(true);
    setEvaluationData({type: "trivia", id: trivia._id});
    setTriviaSelected(trivia)
    setTriviaGameSelectedId(trivia._id);
    //getTriviaGame(trivia._id);
  }

  useEffect(() => {

    setLoadingRanking(true);
    getTrivia();

    return () => {}
  }, [])

  useEffect(() => {

    if(triviaRanking){

      handleRankingData();

    }

    return () => {}
  }, [triviaRanking])

  const handleRankingData = () => {
    
    setLoadingRanking(false);
    //positions
    if('user_position' in triviaRanking){
      setUserScore(triviaRanking.user_position.score);
      setUserPosition(triviaRanking.user_position.position);
    }


    if(triviaRanking?.positions[0]){
      let data = {};
      let name = [];
      if(triviaRanking?.positions[0].user_name){
        name.push(triviaRanking?.positions[0].user_name)
      }
      if(triviaRanking?.positions[0].user_last_name){
        name.push(triviaRanking?.positions[0].user_last_name)
      }
      data.name = name.join(" ");
      data.score = triviaRanking?.positions[0].score;
      data.image = triviaRanking?.positions[0].user_avatar;

      setFirstPlace(data);
    }

    if(triviaRanking?.positions[1]){
      let data = {};
      let name = [];
      if(triviaRanking?.positions[1].user_name){
        name.push(triviaRanking?.positions[1].user_name)
      }
      if(triviaRanking?.positions[1].user_last_name){
        name.push(triviaRanking?.positions[1].user_last_name)
      }
      data.name = name.join(" ");
      data.score = triviaRanking?.positions[1].score;
      data.image = triviaRanking?.positions[1].user_avatar;

      setSecondPlace(data);
    }

    if(triviaRanking?.positions[2]){
      let data = {};
      let name = [];
      if(triviaRanking?.positions[2].user_name){
        name.push(triviaRanking?.positions[2].user_name)
      }
      if(triviaRanking?.positions[2].user_last_name){
        name.push(triviaRanking?.positions[2].user_last_name)
      }
      data.name = name.join(" ");
      data.score = triviaRanking?.positions[2].score;
      data.image = triviaRanking?.positions[2].user_avatar;

      setThirdPlace(data);
    }


    //setFirstPlace
    /*
    const position_1 = triviaRanking.first_places.filter(ranking => ranking.positions === 1);
    const position_2 = triviaRanking.first_places.filter(ranking => ranking.positions === 2);
    const position_3 = triviaRanking.first_places.filter(ranking => ranking.positions === 3);

    if(position_1.length){
      setFirstPlace(position_1[0]);
    }
    if(position_2.length){
      setSecondPlace(position_2[0]);
    }
    if(position_3.length){
      setThirdPlace(position_3[0]);
    }
    */

  }

  const handleReglamento = () => {
    window.open('pdfs/Reglamento_CONCURSO_EXPERTRIVIA_PROMO_STAR_WARS_RACERS_1503_2026.pdf', '_blank').focus();
  }

  useEffect(() => {


    return () => {}
  }, [triviaRanking])

  
  useEffect(() => {
    /*
    if(triviaGame){
      setEvaluation({evaluation: triviaGame});
      setEvaluationData({type: "trivia", id: triviaGame._id});
      setEvaluationOpen(true);
    }
    */
    return () => {}
  }, [triviaGame])

  useEffect(() => {

    getTriviaRanking();
  
    return () => {}
  }, [])
  

  return (
    <StyledWrapper>

      <ModalTriviaStyled
          className='scrolleable'
          open={openModalTrivia}
          onClose={handleCloseModalTrivia}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Fade in={openModalTrivia}>
              <div className="inner_modal_contact_message">
                  <ButtonClose onClick={() => handleCloseModalTrivia()}>
                  <div className="icon">
                      <RiCloseCircleLine />
                  </div>
                  </ButtonClose>
                  <div className='texto_mensaje'>
                  <strong>¡YA SE HABILITO! EXPERTRIVIA MÁS POWER QUE NUNCA.</strong><br/><br/>
                  <strong>RECORDÁ:</strong><br/><br/>
•	Una sola partida con 10 preguntas.<br/>
•	Tenés tiempo para participar desde el 20 al 23 de mayo inclusive.<br/>
•	Una única chance: repasá bien el curso en Campus antes de jugar.<br/>
•	Los que respondan correctamente la partida completa, ¡participan del sorteo!<br/>
•	No importa el podio o puesto en el ranking mientras tengas tus 10 respuestas correctas, ya estás participando.<br/>
•	Sorteo de 10 ganadores de Gorras, Botellas y Mochilas Merchandising Oficial Ferrari.<br/>
•	Es obligatorio haber completado el curso Más Power que Nunca para calificar al premio.<br/><br/>
<strong>¡ÉXITOS PARA TODOS!</strong>
                  </div>
              </div>
          </Fade>
      </ModalTriviaStyled> 

      <ModalStyled
        open={evaluationOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        //onBackdropClick={(event) => {event.stopPropagation(); return false;}}
        disableEscapeKeyDown
      >
        <Fragment>
          {evaluationData && triviaSelected && setEvaluation &&
              <Trivia
                _id={triviaGameSelectedId}
                scope={"trivia"}
                title={triviaSelected.name}
                parentData={triviaSelected}
                evaluation={evaluation}
                setEvaluation={setEvaluation}
                evaluationData={evaluationData}
                setEvaluationData={setEvaluationData}
                handleClose={handleClose}
                setUserScore={setUserScore}
                userScore={userScore}
                setUserPosition={setUserPosition}
                userPosition={userPosition}
              />
          }
        </Fragment>
      </ModalStyled>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='tabs_box'>
          <Tabs TabIndicatorProps={{ style: { display: 'none' } }} value={value} onChange={handleChange} aria-label="basic tabs example" className='tabs'>
            <Tab label={<div className='title_tab'><p>Trivia</p></div>} className='tab tab_trivia' />
            <Tab label={<div className='title_tab'><p>Ranking</p></div>} className='tab tab_ranking' />
          </Tabs>
          
          <div className='trivia_header_user_data'>
            <div className='trivia_box_points'>
              <div className='trivia_icon'>
                <img src={trivia_star_sp} />
              </div>
              <div className='trivia_data'>
                <div className='trivia_points'>
                  <div className='trivia_label'>Tus puntos:</div>
                  <div className='trivia_value'>{ userScore }</div>
                </div>
                <div className='trivia_ranking'>
                  <div className='trivia_label'>Tu puesto:</div>
                  <div className='trivia_value'>{ userPosition }</div>
                </div>
              </div>
            </div>
          </div>
        </Box>
        <CustomTabPanel value={value} index={0} className='panel_tab'>
          <div className="elements">
            {trivia ?
              trivia.length ?
              trivia.map((element, index) => {
              return(
                <div className={`element ${(element.user_status_game === 0 || element.user_status_game === 2) ? "active" : (element.one_shot === false) ? "active" : ""}`} onClick={() => (element.user_status_game === 0 || element.user_status_game === 2) ? handleGetGame(element) : (element.one_shot === false) ? handleGetGame(element) : null }>
                {/* <div className={`element ${element.user_status_game === 0 ? "active" : ""}`} onClick={() => element.user_status_game === 0 ? handleGetGame(element) : null }> */}
                  <div className='left'>
                    <div className='image'>
                      <img src={element.image} />
                    </div>
                    <div className='data'>
                      <div className='title'>{element.name}</div>
                      <div className='description'>{element.description}</div>
                      <div className='label_status'>
                        {element.user_status_game === 4 ? <div className='ended'>FINALIZADO</div> : ''}
                        {(element.user_status_game === 0 && element.user_status_game !== 4) ? <div className='pending'>PENDIENTE</div> : ''}
                        {(element.user_status_game !== 0 && element.user_status_game !== 4 /*&& element.one_shot === true*/) ? <div className='approved'>COMPLETO</div> : ''}
                        <div className='text_status_game'>
                          {(element.user_status_game === 2 && element.user_status_game !== 4) ? "¡Jugá de nuevo!" : ""}
                          {(element.user_status_game === 3 && element.user_status_game !== 4) ? "¡Nuevo intento mañana!" : ""}
                        </div>

                        
                        {/* {element.score ? <div className='score'>{element?.score} puntos</div> : ""} */}
                      </div>

                      <div className='trivia_bottom_actions' onClick={(e) => e.stopPropagation()}>
        
                        <ButtonYellow
                            className="bt"
                            onClick={() => handleReglamento()}
                            disabled={false}
                            css_styles={{background:{normal: '#FFD200', hover: '#000000'}}}
                          >
                            <p>Reglamento</p>
                        </ButtonYellow>

                      </div>

                    </div>
                  </div>
                  <div className='right'>
                    <div className='icon_arrow'>
                      <HiArrowRight />
                    </div>
                  </div>
                </div>
              )
            }) : <div className="trivia_endend">¡ExperTrivia no se encuentra disponible!</div> : <div className='loader'><CircularProgress /></div>}

          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1} className='panel_tab panel_tab_podium'>
          <div className='box_ranking'>
            {!loadingRanking ?
            <>
            {/* <div className='own_ranking_data'>
              <div className='own_points'>
                <div className='label'>Tus puntos:</div> 
                <div className='value'>123456</div>
              </div>
              <div className='own_position'>
                <div className='label'>Tu puesto:</div> 
                <div className='value'>1</div>
              </div>
            </div>
            {triviaRanking?.last_positions && triviaRanking?.last_positions.map((pos, index) => {
              if(pos.user_position){
                return (
                  <div className='own_ranking_data'>
                    <div className='own_points'>
                      <div className='label'>Tus puntos:</div> 
                      <div className='value'>{pos.score}</div>
                    </div>
                    <div className='own_position'>
                      <div className='label'>Tu puesto:</div> 
                      <div className='value'>{pos.positions}</div>
                    </div>
                  </div>
                )
              }
            })} */}

            <div className='top'>

              <div className='box_podium'>
                <div className='podium'>
                  <img src={"images/podio.png"} />
                </div>
                <div className='podium_1'>
                  <div className='image'>
                    <div className='crown'>
                      <img src='/images/crown.png' />
                    </div>
                    {firstPlace && firstPlace.image ?
                      <img src={firstPlace.image} alt="" />
                    :
                      <img src="/images/noavatar.jpg" />
                    }
                  </div>
                  <div className='name'>{firstPlace ? firstPlace.name : 'Vacante'}</div>

                  {firstPlace ?
                  <div className='points'>
                    <div className='value'>{firstPlace?.score}</div>
                    <div className='pts'>pts</div>
                  </div> : ''}

                </div>
                <div className='podium_2'>
                  <div className='image'>
                    {secondPlace && secondPlace.image ?
                      <img src={secondPlace.image} alt="" />
                    :
                      <img src="/images/noavatar.jpg" />
                    }
                  </div>
                  <div className='name'>{secondPlace ? secondPlace.name : 'Vacante'}</div>

                  {secondPlace ?
                  <div className='points'>
                    <div className='value'>{secondPlace?.score}</div>
                    <div className='pts'>pts</div>
                  </div> : ''}

                </div>
                <div className='podium_3'>
                  <div className='image'>
                    {thirdPlace && thirdPlace.image ?
                      <img src={thirdPlace.image} alt="" />
                    :
                      <img src="/images/noavatar.jpg" />
                    }
                  </div>
                  <div className='name'>{thirdPlace ? thirdPlace.name : 'Vacante'}</div>

                  {thirdPlace ?
                  <div className='points'>
                    <div className='value'>{thirdPlace?.score}</div>
                    <div className='pts'>pts</div>
                  </div> : ''}

                </div>
              </div>
              
              {/* <div className='position_2'>
                <div className='icon'>
                  <img src="images/trivia_position_2.svg" />
                </div>
                <div className='base'></div>
                <div className='avatar'>
                  {secondPlace && secondPlace.image ?
                    <img src={secondPlace.image} alt="" />
                  : 
                    <img src="/images/noavatar.jpg" />
                  }
                </div>
                <div className='name'>{secondPlace?.name}</div>
              </div>
                
              <div className='position_1'>
                <div className='icon'>
                  <img src="images/trivia_position_1.svg" />
                </div>
                <div className='base'></div>
                <div className='avatar'>
                  {firstPlace && firstPlace.image ?
                    <img src={firstPlace.image} alt="" />
                  :
                    <img src="/images/noavatar.jpg" />
                  }
                </div>
                <div className='name'>{firstPlace?.name}</div>
              </div>

              <div className='position_3'>
                <div className='icon'>
                  <img src="images/trivia_position_3.svg" />
                </div>
                <div className='base'></div>
                <div className='avatar'>
                  {thirdPlace && thirdPlace.image ?
                    <img src={thirdPlace.image} alt="" />
                  :
                    <img src="/images/noavatar.jpg" />
                  }
                </div>
                <div className='name'>{thirdPlace?.name}</div>
              </div> */}

            </div>

            <div className='list_ranking'>
              <div className='items'>
                {triviaRanking?.positions && triviaRanking?.positions.map((pos, index) => {
                  return(
                    <div className={`item${pos.user_position ? ' is_own' : ''}`}>
                      <div className='left'>
                        <div className='points'>{pos.score} pts</div>
                        <div className='name'>{pos.user_name + ' ' + pos.user_last_name}</div>
                        {pos.position === userPosition ? <div className='own'>¡Tu estas aqui!</div> : ''}
                      </div>
                      <div className='right'>
                        <div className='position'>Puesto {pos.position}º</div>
                        <div className='avatar'>
                          {pos.image ?
                            <img src="/images/noavatar.jpg" />
                            // <img src={pos.image} alt="" />
                          :
                            <img src="/images/noavatar.jpg" />
                          }
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            </>
            :
            <div className='loader'>
              <CircularProgress />
            </div>
            }
          </div>
        </CustomTabPanel>
      </Box>
    </StyledWrapper>
  )
}

export default TriviaContainer;
